<template>
  <div>
    <transition name="fade-auth" mode="out-in" appear>
      <div v-if="loading" :key="1" class="auth-window">
        <Loader />
        <p>{{ loadingMessage }}</p>
      </div>
      <div v-else :key="2">
      <transition name="fade-auth" mode="out-in" appear>
        <div v-if="formType === 1" :key="1" class="auth-window">
          <LoginForm  />
        </div>
        <div v-else-if="formType === 2" :key="2" class="auth-window">
          <RegistrationForm  />
        </div>
      </transition>
      </div>
    </transition>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';
import LoginForm from '@/components/authentication/LoginForm.vue';
import RegistrationForm from '@/components/authentication/RegistrationForm.vue';

export default {
  name: "Authentication",
  components: {
    Loader,
    LoginForm,
    RegistrationForm
  },
  computed: {
    sessionExpired() {
      return this.$store.getters.sessionExpired;
    },
    loading() {
      return this.$store.getters.loading;
    },
    loadingMessage() {
      return this.$store.getters.loadingMessage;
    },
    formType() {
      return this.$store.getters.formType;
    }
  }
};
</script>

<style lang="scss" scoped>
.auth-window {
  margin-top: 100px;
  margin-bottom: 25px;
  padding: 20px;
  border-radius: 10px;
  background: #2a2a2a;
  margin-left: auto;
  margin-right: auto;
  width: 50vw;
  min-height: 45vh;
  text-align: center;

  @media only screen and (max-width: 768px) {
    width: 95vw;
  }
}
</style>
